<template>

  <a
    href="javascript:void(0)"
    class="list-group-item list-group-item-action"
    @click="setMe(account._id)">
    {{ account.name }}
    </a>

</template>

<script>
import cookie from 'js-cookie'

export default {
  name: 'Account',
  components: {
  },
  props: [
    'account'
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    setMe
    */
    setMe (accountId) {
      cookie.set('selected_account_id', accountId, { expires: 60 }) // save
      this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MyAccount/MyAccountItem.vue